import * as service_test from '../../../service-test/src/lib/setup/json/service-setup.json';
import * as truespeed_test from '../../../truespeed-test/src/lib/setup/config/truespeed-setup.json';
import * as voip_test from '../../../voip-test/src/lib/setup/json/voip-test.json';
import * as network_test from '../../../network-test/src/lib/json/network-test.json';
import * as twamp_test from '../../../twamp-test/src/lib/json/twamp-test.json';
import * as multistep_test from '../../../multi-step-test/src/lib/json/multi-step-setup.json';
import * as y1564_test from '../../../y1564-test/src/lib/y1564-test/setup/config/y1564-setup.json';
import * as rfc2544_test from '../../../rfc2544-test/src/lib/rfc2544-test/setup/config/rfc2544-setup.json';
import * as y1731_test from '../../../y1731-test/src/lib/y1731-test/setup/config/y1731-setup.json';
import * as udp_test from '../../../udp-test/src/lib/udp-test/setup/config/udp-setup.json';
import * as http_test from '../../../http-test/src/lib/http-test/setup/config/http-setup.json';
import * as ftp_test from '../../../ftp-test/src/lib/ftp-test/setup/config/ftp-setup.json';
import * as twamp_reflector_test from '../../../twamp-reflector-test/src/lib/model/twamp-reflector-test.json';
import * as bert_test from '../../../bert-test/src/lib/bert-test/setup/config/bert-setup.json';
//AgentModel
import { TRUESPEED_AGENT_MODEL_CONFIG } from '../../../truespeed-test/src/lib/setup/config/truespeed-agent-model';
import { Y1564_AGENT_MODEL_CONFIG } from '../../../y1564-test/src/lib/y1564-test/setup/config/y1564-agent-model';
import { SERVICE_AGENT_MODEL_CONFIG } from '../../../service-test/src/lib/setup/json/service-agent-model';
import { MULTISTEP_AGENT_MODEL_CONFIG } from '../../../multi-step-test/src/lib/json/multi-step-agent-model';
import { VOIP_AGENT_MODEL_CONFIG } from '../../../voip-test/src/lib/setup/json/voip-agent-model';
import { TWAMP_AGENT_MODEL_CONFIG } from '../../../twamp-test/src/lib/json/twamp-agent-model';
import { RFC2544_AGENT_MODEL_CONFIG } from '../../../rfc2544-test/src/lib/rfc2544-test/setup/config/rfc2544-agent-model';
import { Y1731_AGENT_MODEL_CONFIG } from '../../../y1731-test/src/lib/y1731-test/setup/config/y1731-agent-model';
import { UDP_AGENT_MODEL_CONFIG } from '../../../udp-test/src/lib/udp-test/setup/config/udp-agent-model';
import { HTTP_AGENT_MODEL_CONFIG } from '../../../http-test/src/lib/http-test/setup/config/http-agent-model';
import { FTP_AGENT_MODEL_CONFIG } from '../../../ftp-test/src/lib/ftp-test/setup/config/ftp-agent-model';
import { TWAMP_REFLECTOR_MODEL_CONFIG } from '../../../twamp-reflector-test/src/lib/model/twamp-reflector-agent-model';
import { BERT_AGENT_MODEL_CONFIG } from '../../../bert-test/src/lib/bert-test/setup/config/bert-agent-model';

const widgets = [
  truespeed_test,
  service_test,
  voip_test,
  network_test,
  twamp_test,
  multistep_test,
  y1564_test,
  rfc2544_test,
  y1731_test,
  udp_test,
  http_test,
  ftp_test,
  twamp_reflector_test,
  bert_test
];

const agentModels = [
  TRUESPEED_AGENT_MODEL_CONFIG,
  Y1564_AGENT_MODEL_CONFIG,
  SERVICE_AGENT_MODEL_CONFIG,
  MULTISTEP_AGENT_MODEL_CONFIG,
  VOIP_AGENT_MODEL_CONFIG,
  TWAMP_AGENT_MODEL_CONFIG,
  RFC2544_AGENT_MODEL_CONFIG,
  Y1731_AGENT_MODEL_CONFIG,
  UDP_AGENT_MODEL_CONFIG,
  HTTP_AGENT_MODEL_CONFIG,
  FTP_AGENT_MODEL_CONFIG,
  TWAMP_REFLECTOR_MODEL_CONFIG,
  BERT_AGENT_MODEL_CONFIG
];

//eslint-disable-next-line @typescript-eslint/no-explicit-any
export function loadTestSetup(): any {
  const result = {};
  for (const widget of widgets) {
    result[widget.id] = widget;
  }
  return result;
}

//eslint-disable-next-line @typescript-eslint/no-explicit-any
export function loadTestAgentModel(): any {
  const result = {};
  for (const models of agentModels) {
    result[models.id] = models;
  }
  return result;
}

export interface IAgentConfig {
  agentType: string;
  tabsConfig: Array<ITabsConfig>;
}

export interface ITabsConfig {
  tabId: string;
  valuesDefault: outputParams;
  outputs: Array<string>;
  outputOptional: Array<string>;
  restoreOutputs: Array<string>;
  options: outputParams;
  lookup: outputParams;
}

export type outputParams = {
  //eslint-disable-next-line
  [key: string]: string | any;
};
